import type { Application } from "../models";
import { userCan, ActionForUserCan } from "../helpers/roles";
import {
  useMaybeCurrentOperationData,
  useCurrentOperationData,
} from "../next/hooks/operations";

/**
 * @deprecated
 */
export const useMaybeUserCan = (
  action: ActionForUserCan,
  model: string,
  application: Application,
): boolean | undefined => {
  const currentOperation = useMaybeCurrentOperationData();
  if (currentOperation === undefined) {
    return undefined;
  }
  return userCan(action, model, application, currentOperation);
};

/**
 * @deprecated
 */
export const useUserCan = (
  action: ActionForUserCan,
  model: string,
  application: Application,
): boolean => {
  const currentOperation = useCurrentOperationData();
  return userCan(action, model, application, currentOperation);
};
